function Footer() {
    return (
        <footer>
{/* 
            <div className="footer-main">
                <div className="footer-area footer-padding">
                    <div className="container">
                        <div className="row  justify-content-between">
                            <div className="col-lg-3 col-md-4 col-sm-8">
                                <div className="single-footer-caption mb-30">

                                    <div className="footer-logo">
                                        <a href="https://preview.colorlib.com/theme/appco/index.html"><img src="./App Landing Template_files/xlogo2_footer.png.pagespeed.ic.TPJcIPa4Tw.webp" alt=""></img></a>
                                    </div>
                                    <div className="footer-tittle">
                                        <div className="footer-pera">
                                            <p className="info1">Lorem ipsum dolor sit amet, consectetur adipisicing elit sed do eiusmod tempor incididunt ut labore.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-5">
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>Quick Links</h4>
                                        <ul>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">About</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Features</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Pricing</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Download</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Reviews</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-2 col-md-4 col-sm-7">
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>Support</h4>
                                        <ul>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Report a bug</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Privacy Policy</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Terms &amp; Conditions</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">Sitemap</a></li>
                                            <li><a href="https://preview.colorlib.com/theme/appco/#">FAQs</a></li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6 col-sm-8">
                                <div className="single-footer-caption mb-50">
                                    <div className="footer-tittle">
                                        <h4>Newsletter</h4>
                                        <div className="footer-pera footer-pera2">
                                            <p>Heaven fruitful doesn't over lesser in days. Appear </p>
                                        </div>

                                        <div className="footer-form">
                                            <div id="mc_embed_signup">
                                                <form target="_blank" action="https://spondonit.us12.list-manage.com/subscribe/post?u=1462626880ade1ac87bd9c93a&amp;id=92a4423d01" className="subscribe_form relative mail_part" noValidate={true}>
                                                    <input type="email" name="EMAIL" id="newsletter-form-email" placeholder=" Email Address " className="placeholder hide-on-focus" onFocus={()=>{console.log('&#39;&#39;')}} onBlur={()=>console.log('&#39; Email Address &#39;')}></input>
                                                        <div className="form-icon">
                                                            <button type="submit" name="submit" id="newsletter-submit" className="email_icon newsletter-submit button-contactForm"><img src="./App Landing Template_files/xform_icon.png.pagespeed.ic.myHEUnsh8f.webp" alt=""></img></button>
                                                        </div>
                                                        <div className="mt-10 info"></div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="row align-items-center">
                            <div className="col-xl-12 ">
                                <div className="footer-copy-right">
                                    <p>
                                        Copyright ©<script>document.write(new Date().getFullYear());</script>2022 All rights reserved | This template is made with <i className="ti-heart" aria-hidden="true"></i> by <a href="https://colorlib.com/" target="_blank">Colorlib</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}

        </footer>
    );
}

export default Footer;
